import { render, staticRenderFns } from "./login2.vue?vue&type=template&id=db27145e&scoped=true"
import script from "./login2.vue?vue&type=script&lang=js"
export * from "./login2.vue?vue&type=script&lang=js"
import style0 from "./login2.vue?vue&type=style&index=0&id=db27145e&prod&lang=less&scoped=true"
import style1 from "./login2.vue?vue&type=style&index=1&id=db27145e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db27145e",
  null
  
)

export default component.exports